import { ChangeDetectionStrategy, Component, computed, input, linkedSignal } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { QuestionSection, QuestionView, sectionsFor } from '@formrails/form-builder/data-access';
import { QuestionListComponent } from '../question-list/question-list.component';

/** A saved template laid out the way an applicant meets it: one tab per section. */
@Component({
  selector: 'app-preview-sections',
  standalone: true,
  imports: [TabsModule, QuestionListComponent],
  templateUrl: './preview-sections.component.html',
  styleUrl: './preview-sections.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewSectionsComponent {
  readonly questions = input<QuestionView[]>([]);
  readonly showQuestionNumbers = input(true);

  readonly sections = computed(() => sectionsFor(this.questions()));

  /** Typed as p-tabs declares its value; another template opens at its first section. */
  readonly activeIndex = linkedSignal<QuestionSection[], string | number | undefined>({
    source: this.sections,
    computation: () => 0
  });
}
